/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Files_Filters_Ingested_SinceInputs */

const es_settings_files_filters_ingested_since = /** @type {(inputs: Settings_Files_Filters_Ingested_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestado desde`)
};

const en_settings_files_filters_ingested_since = /** @type {(inputs: Settings_Files_Filters_Ingested_SinceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingested since`)
};

/**
* | output |
* | --- |
* | "Ingested since" |
*
* @param {Settings_Files_Filters_Ingested_SinceInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_files_filters_ingested_since = /** @type {((inputs?: Settings_Files_Filters_Ingested_SinceInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Files_Filters_Ingested_SinceInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_files_filters_ingested_since(inputs)
	return en_settings_files_filters_ingested_since(inputs)
});
export { settings_files_filters_ingested_since as "settings.files.filters.ingested_since" }